import {Injectable} from '@angular/core';

/**
 * Сервис локального хранилища браузера, для хранения настроек в браузере пользователя для его удобства
 */

@Injectable()
export class BrowserStorageService {
    static set(key: BrowserStorageDataEnum, value: any) {
        if ([null, undefined].includes(key)) {
            return;
        }

        if (localStorage) {
            localStorage.setItem(key, value);
        }
    }

    static get(key: BrowserStorageDataEnum) {
        if ([null, undefined].includes(key)) {
            return null;
        }

        return localStorage ? localStorage.getItem(key) : null;
    }
}

export enum BrowserStorageDataEnum {
    /**
     * Сколько элементов на страницу показывать в складе оборудования
     */
    equipmentStorageItemsPerPageCount = 'equipmentStorageItemsPerPageCount',

    /**
     * Сколько элементов на страницу показывать в списке объектов
     */
    workingObjectsItemsPerPageCount = 'workingObjectsItemsPerPageCount',

    /**
     * Сколько элементов на страницу показывать в списке заключений
     */
    conclusionItemsPerPageCount = 'conclusionItemsPerPageCount',
}
